import React from 'react';


class NavTabs extends React.Component {  
    
  constructor(props) 
  {
    super(props)

    this.state = {
      cacheIsShown: props.cacheIsShown,
      networkIsShown: props.networkIsShown,
      viewerIsShown: props.viewerIsShown,
      application: props.application,

     
    } 
  }
    render() { 
       
        return (

     <div className="NavTabs bg-secondary text-white rounded-lg p-4">     
     <ul className="nav nav-tabs bg-secondary md-tabs" id="myTabMD" role="tablist">

    
     <li className="nav-item ">

    <a className={"nav-link active btn btn-sm m-2 " + 
    (this.props.cacheIsShown || this.props.networkIsShown || this.props.viewerIsShown ? 
      "btn-secondary" : "btn-warning")} id="home-tab-md" data-toggle="tab" href="#home-md" role="tab" 
      aria-controls="network-md"
      aria-selected="true" onClick={this.props.handleHomePage}>Home</a>
  </li>

  <li className="nav-item">
    <a className={"nav-link active btn btn-sm m-2 " + 
    (this.props.cacheIsShown ? "btn-warning" : "btn-secondary")}  id="cache-tab-md" data-toggle="tab" href="#cache-md" role="tab" 
    aria-controls="cache-md"
      aria-selected="false" onClick={this.props.handleShowCache}>Cache</a>
  </li>

  <li className="nav-item">
    <a className={"nav-link active btn btn-sm m-2 " + 
    (this.props.networkIsShown ? "btn-warning" : "btn-secondary")} id="network-tab-md" data-toggle="tab" href="#network-md" role="tab" 
    aria-controls="network-md"
      aria-selected="false" onClick={this.props.handleShowNetwork}>Network</a>
  </li>
  
  <li className="nav-item">
    <a className={"nav-link active btn btn-sm m-2 " + 
    ( this.props.viewerIsShown ? "btn-warning" : "btn-secondary")} id="viewer-tab-md" data-toggle="tab" href="#viewer-md" role="tab"
     aria-controls="viewer-md"
      aria-selected="false" onClick={this.props.handleShowViewer}>Viewer</a>
  </li>

  <li className="nav-item">
    <a className={"nav-link active btn btn-sm m-2 " + 
    ( (this.props.application.current_manifest_status === "ok") ? "btn-warning" : "btn-secondary")} id="viewer-tab-md" data-toggle="tab" 
    href="#viewer-md" role="tab" aria-controls="viewer-md"
      aria-selected="false" onClick={this.props.handleClearAll}>Clear All</a>
  </li>
</ul>
   </div>
        );
    }
}


export default NavTabs;